module.exports = __webpack_public_path__ + "static/media/migraine-nav.e7eebbbf.png";